// extracted by mini-css-extract-plugin
module.exports = {"eventContent":"styles_eventContent__3aIcL","policyIcon":"styles_policyIcon__2gVAC","attentionIcon":"styles_attentionIcon__3ODYN","absolute":"styles_absolute__3xGcv"};